import {
  COMPONENT_VALUE_TYPES as types,
  COMPONENT_COLOR_THEMES,
  FLEX_DIRECTION,
  ACCORDION_LAYOUT
} from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
    items: {
        title: string,
        description: string,
        image: string,
    }[],
}

const propsSchema: PropsSchemaList = [
    {
        key: 'items',
        label: 'Images',
        type: types.ARRAY,
        options: {
            maxLength: 8
        },
        children: [
            {
                key: 'title',
                label: 'Title',
                type: types.TEXT,
                options: {
                    maxLength: 20
                }
            },
            {
                key: 'description',
                label: 'Description',
                type: types.TEXT,
                options: {
                    maxLength: 100 
                }
            },
            {
                key: 'image',
                label: 'Image',
                type: types.S3_ASSET_URL,
            }
        ],
    }
];

const defaultProps: Props = {
    items: [
        {
        title: 'King of Red-carpet',
        description: 'Born for the spotlight. The ultimate and preferred choice for A-list travel.',
        image: 'https://genesis-cdn.ff.com/FX/Unofficial-Pic/original/711----0574.jpg', 
        },
        {
        title: 'Mobile Livestream Studio',
        description: 'The perfect vehicle for livestreaming, content creation, and brand promotion.',
        image: 'https://genesis-cdn.ff.com/FX/Unofficial-Pic/original/711----0585.jpg', 
        },
        {
        title: 'Advanced Ergonomics',
        description: 'Advanced Ergonomics Advanced Ergonomics Advanced Ergonomics Advanced Ergonomics.',
        image: 'https://genesis-cdn.ff.com/FX/Unofficial-Pic/original/711----0372.jpg', 
        },
        {
        title: 'Mobile AI Office',
        description: 'Seamless business, stay connected with SUPER AP, live meeting and AI functions.',
        image: 'https://genesis-cdn.ff.com/FX/Unofficial-Pic/original/711----0093.jpg', 
        },
        {
        title: 'Mobile AI Clubhouse',
        description: 'A private, serene, and supremely comfortable space for VIP meetings.',
        image: 'https://genesis-cdn.ff.com/FX/Unofficial-Pic/original/711----0385.jpg', 
        },
        {
        title: 'Car of Golf',
        description: 'With exceptional comfort and an ultra-large trunk that easily fits multi golf bags, the SuperOne is',
        image: 'https://genesis-cdn.ff.com/FX/Unofficial-Pic/original/711----0358-default.jpg', 
        },
        {
        title: 'Mobile Mansion',
        description: 'Massive interior space and smart features for in-car entertainment, and live sports viewing.',
        image: 'https://genesis-cdn.ff.com/FX/Unofficial-Pic/original/_C3A7166.jpg', 
        },
        {
        title: 'Car of Camping',
        description: 'Massive interior space and smart features for camping, in-car entertainment, and live sports viewing',
        image: 'https://genesis-cdn.ff.com/FX/Unofficial-Pic/original/_C3A5781.jpg', 
        },
    ],
};

export default {
    title: 'Home Page Gallery',
    id: 'HomePageGallery',
    propsSchema,
    defaultProps,
}